import { Stack, Typography } from "@mui/material";
import { moneyFormat } from "utils/Masks/Masks";
import { useState } from "react";
import Switch from "components/Inputs/Switch/Switch";
import CheckIcon from "@mui/icons-material/Check";
import InfoModal from "./InfoModal/InfoModal";

export default function CardServiceNew({
    title,
    description,
    value,
    serviceDeadline,
    paymentDeadline,
    id,
    onSelect,
    isSelected,
}) {
    const [openModalMore, setOpenModalMore] = useState(false);

    return (
        <Stack
            borderRadius={"8px"}
            border={isSelected ? "4px solid #00A326" : "2px solid #01C4FE"}
            p={isSelected ? "36px" : "38px"}
            alignItems={`center`}
            justifyContent={"center"}
            textAlign={"center"}
            maxWidth={"350px"}
            height={"300px"}
            position={"relative"}
            onClick={() => {
                if (openModalMore) return;
                onSelect(isSelected ? null : id);
            }}
            sx={{
                cursor: "pointer",
            }}
        >
            {isSelected && (
                <Stack
                    sx={{
                        position: "absolute",
                        top: -30,
                        left: "44%",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        border: "4px solid #00A326",
                        p: 1,
                    }}
                >
                    <CheckIcon
                        sx={{
                            color: "#00A326",
                            fontSize: 30,
                        }}
                    />
                </Stack>
            )}

            <Typography
                color="#053462"
                fontSize={"18px"}
                fontWeight={600}
                fontStyle={"italic"}
                mb={"48px"}
            >
                {title}
            </Typography>
            <Stack
                border={"1.5px solid #01C4FE"}
                borderRadius={"41px"}
                p={"10px 20px"}
                mb={"48px"}
            >
                {value > 0 ? moneyFormat(value) : "R$ 0,00"}
            </Stack>
            <Typography
                color="#636363"
                fontSize={"12px"}
                fontWeight={500}
                sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {description}
            </Typography>
            <Stack
                justifyContent={"space-between"}
                direction={"row"}
                mt={"28px"}
                width={"100%"}
            >
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{ cursor: "pointer" }}
                    gap={0.5}
                >
                    <Stack mb={"5px"}>
                        <Switch
                            checked={isSelected}
                            onChange={() => onSelect(id)}
                        />
                    </Stack>
                    <Typography
                        fontSize={"14px"}
                        fontWeight={700}
                        color="#01C4FE"
                    >
                        Selecionar
                    </Typography>
                </Stack>
                <Stack
                    sx={{
                        cursor: "pointer",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpenModalMore(true);
                    }}
                >
                    <Typography
                        fontSize={"14px"}
                        fontWeight={700}
                        color="#01C4FE"
                    >
                        Ver mais
                    </Typography>
                </Stack>
            </Stack>
            <InfoModal
                open={openModalMore}
                onSelect={() => {
                    onSelect(id);
                }}
                onClose={() => setOpenModalMore(false)}
                title={title}
                description={description}
                serviceDeadline={serviceDeadline}
                paymentDeadline={paymentDeadline}
            />
        </Stack>
    );
}
